import styled from "@emotion/styled";
import { border } from "@smartsheet/design-tokens";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { checkboxBorderTheme } from "../checkboxTheme";

const getSize = (props: CheckboxWrapperProps) => props.size;

interface CheckboxWrapperProps {
    size: 16 | 20;
    themeMode: RequiredThemeKeys;
}

export const CheckmarkWrapper = styled("div")<CheckboxWrapperProps>`
    // border color is managed from the CheckboxIcon component.
    border-width: ${({ themeMode }) => (themeMode.includes("ursa") ? border.width10 : border.width20)};
    border-style: solid;
    border-radius: ${({ themeMode, size }) => checkboxBorderTheme.borderRadius[size](themeMode)};

    box-sizing: border-box;
    height: var(--sds--checkbox--visual-size, ${getSize}px);
    width: var(--sds--checkbox--visual-size, ${getSize}px);

    flex: none;
`;

CheckmarkWrapper.displayName = "CheckboxWrapper";
